import { render, staticRenderFns } from "./LayerEditModal.vue?vue&type=template&id=3976ffb4&"
import script from "./LayerEditModal.vue?vue&type=script&lang=js&"
export * from "./LayerEditModal.vue?vue&type=script&lang=js&"
import style0 from "./LayerEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports